import { createBrowserRouter, Navigate, useSearchParams, type RouteObject } from "react-router";
import { PostPage } from "../pages/PostPage";
import { PostsPage } from "../pages/PostsPage";
import { ComposePage } from "../pages/ComposePage";
import { DiscoverPage } from "../pages/DiscoverPage";
import { HistoryPage } from "../pages/HistoryPage";
import { GuidePage } from "../pages/GuidePage";
import { LibraryPage } from "../pages/LibraryPage";
import { ModerationPage } from "../pages/ModerationPage";
import { MomentEditPage } from "../pages/MomentEditPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { NowPage } from "../pages/NowPage";
import { PerformancePage } from "../pages/PerformancePage";
import { PlaylistPage } from "../pages/PlaylistPage";
import { SearchPage } from "../pages/SearchPage";
import { WorkPage } from "../pages/WorkPage";
import { AppShell } from "./AppShell";

export const routes: RouteObject[] = [
  {
    element: <AppShell />,
    children: [
      { index: true, element: <DiscoverPage /> },
      { path: "now", element: <NowPage /> },
      { path: "guide", element: <GuidePage /> },
      { path: "search", element: <SearchPage /> },
      { path: "works/:id", element: <WorkPage /> },
      { path: "performances/:id", element: <PerformancePage /> },
      { path: "posts/:id", element: <PostPage /> },
      { path: "posts", element: <PostsPage /> },
      { path: "compose", element: <ComposePage /> },
      { path: "register", element: <RegistrationRedirect /> },
      { path: "moments/:id", element: <MomentEditPage /> },
      { path: "library", element: <LibraryPage /> },
      { path: "library/playlists/:id", element: <PlaylistPage /> },
      { path: "history", element: <HistoryPage /> },
      { path: "moderation", element: <ModerationPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
];

function RegistrationRedirect() {
  const [params] = useSearchParams();
  const url = params.get("url");
  return <Navigate to={url ? `/search?q=${encodeURIComponent(url)}` : "/search"} replace />;
}

export function createAppRouter() {
  return createBrowserRouter(routes);
}
